import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';
import React from 'react';

const RequiredDot: React.FC = () => {
  const { root } = useStyles();

  return <span className={root}>*</span>;
};

export default RequiredDot;

const useStyles = makeStyles({
  root: {
    color: colorSet.errorBase
  }
});
